import React from "react";

const Placeholder = () => {
  return (
    <div>
      <h2>Placeholder</h2>
      <p>This is placeholder content for future use.</p>
    </div>
  );
};

export default Placeholder;
